import {useCallback} from 'react'

import {type OnDragEvent} from '../types'

import {useDragRange} from './useDragRange'

type Props = {
  totalRunningTimeMs: number
  dragRunningTimeIndex?: number
  onDragEnd?: OnDragEvent
  onMove?: OnDragEvent
}

export const useStackedBarDragRange = ({
  totalRunningTimeMs,
  dragRunningTimeIndex,
  onDragEnd,
  onMove
}: Props) => {
  const handleDragEnd = useCallback(
    (range: {percentStart: number; percentEnd: number}) => {
      onDragEnd?.({...range, totalRunningTimeMs, index: dragRunningTimeIndex})
    },
    [dragRunningTimeIndex, onDragEnd, totalRunningTimeMs]
  )
  const handleMouseMoveEvent = useCallback(
    (range: {percentStart: number; percentEnd: number}) => {
      onMove?.({...range, totalRunningTimeMs, index: dragRunningTimeIndex})
    },
    [dragRunningTimeIndex, onMove, totalRunningTimeMs]
  )
  const {containerRef, handleMouseUp, handleMouseMove, handleMouseDown, dragEndX, dragStartX} =
    useDragRange({
      onDragEnd: handleDragEnd,
      onMouseMove: handleMouseMoveEvent,
      disabled: !onDragEnd && !onMove
    })

  return {
    containerRef,
    handleMouseUp,
    handleMouseMove,
    handleMouseDown,
    dragStartX,
    dragEndX
  }
}
